import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div {...{
      "className": "mermaid",
      "data-processed": "true"
    }}><svg parentName="div" {...{
        "id": "mermaid-1661801408000",
        "width": "100%",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlnsXLink": "http://www.w3.org/1999/xlink",
        "height": "302",
        "style": {
          "maxWidth": "472.40625px"
        },
        "viewBox": "0 0 472.40625 302"
      }}><style parentName="svg">{`#mermaid-1661801408000 {font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:16px;fill:#333;}#mermaid-1661801408000 .error-icon{fill:#552222;}#mermaid-1661801408000 .error-text{fill:#552222;stroke:#552222;}#mermaid-1661801408000 .edge-thickness-normal{stroke-width:2px;}#mermaid-1661801408000 .edge-thickness-thick{stroke-width:3.5px;}#mermaid-1661801408000 .edge-pattern-solid{stroke-dasharray:0;}#mermaid-1661801408000 .edge-pattern-dashed{stroke-dasharray:3;}#mermaid-1661801408000 .edge-pattern-dotted{stroke-dasharray:2;}#mermaid-1661801408000 .marker{fill:#333333;stroke:#333333;}#mermaid-1661801408000 .marker.cross{stroke:#333333;}#mermaid-1661801408000 svg{font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:16px;}#mermaid-1661801408000 .label{font-family:"trebuchet ms",verdana,arial,sans-serif;color:#333;}#mermaid-1661801408000 .cluster-label text{fill:#333;}#mermaid-1661801408000 .cluster-label span{color:#333;}#mermaid-1661801408000 .label text,#mermaid-1661801408000 span{fill:#333;color:#333;}#mermaid-1661801408000 .node rect,#mermaid-1661801408000 .node circle,#mermaid-1661801408000 .node ellipse,#mermaid-1661801408000 .node polygon,#mermaid-1661801408000 .node path{fill:#ECECFF;stroke:#9370DB;stroke-width:1px;}#mermaid-1661801408000 .node .label{text-align:center;}#mermaid-1661801408000 .node.clickable{cursor:pointer;}#mermaid-1661801408000 .arrowheadPath{fill:#333333;}#mermaid-1661801408000 .edgePath .path{stroke:#333333;stroke-width:2.0px;}#mermaid-1661801408000 .flowchart-link{stroke:#333333;fill:none;}#mermaid-1661801408000 .edgeLabel{background-color:#e8e8e8;text-align:center;}#mermaid-1661801408000 .edgeLabel rect{opacity:0.5;background-color:#e8e8e8;fill:#e8e8e8;}#mermaid-1661801408000 .cluster rect{fill:#ffffde;stroke:#aaaa33;stroke-width:1px;}#mermaid-1661801408000 .cluster text{fill:#333;}#mermaid-1661801408000 .cluster span{color:#333;}#mermaid-1661801408000 div.mermaidTooltip{position:absolute;text-align:center;max-width:200px;padding:2px;font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:12px;background:hsl(80, 100%, 96.2745098039%);border:1px solid #aaaa33;border-radius:2px;pointer-events:none;z-index:100;}#mermaid-1661801408000 :root{--mermaid-font-family:"trebuchet ms",verdana,arial,sans-serif;}`}</style><g parentName="svg"><g parentName="g" {...{
            "className": "output"
          }}><g parentName="g" {...{
              "className": "clusters"
            }}><g parentName="g" {...{
                "className": "cluster",
                "id": "flowchart-subGraph0-26",
                "transform": "translate(236.203125,106.5)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "width": "456.40625",
                  "height": "197",
                  "x": "-228.203125",
                  "y": "-98.5"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0, -84.5)",
                  "id": "mermaid-1661801408000Text"
                }}><g parentName="g" {...{
                    "transform": "translate(0,0)"
                  }}><foreignObject parentName="g" {...{
                      "width": "0",
                      "height": "0"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}></div></foreignObject></g></g></g></g><g parentName="g" {...{
              "className": "edgePaths"
            }}><g parentName="g" {...{
                "className": "edgePath LS-webapp LE-router",
                "id": "L-webapp-router",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M78.69140625,255L78.69140625,250.83333333333334C78.69140625,246.66666666666666,78.69140625,238.33333333333334,78.69140625,230C78.69140625,221.66666666666666,78.69140625,213.33333333333334,93.87955729166667,204.87573055906887C109.06770833333333,196.41812778480437,139.44401041666666,187.83625556960874,154.63216145833334,183.54531946201095L169.8203125,179.2543833544131",
                  "markerEnd": "url(#arrowhead33)",
                  "style": {
                    "fill": "none",
                    "strokeWidth": "2px",
                    "strokeDasharray": "3"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead33",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 0 0 L 0 0 z",
                      "style": {
                        "fill": "#333"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-iosapp LE-router",
                "id": "L-iosapp-router",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M403.71484375,255L403.71484375,250.83333333333334C403.71484375,246.66666666666666,403.71484375,238.33333333333334,403.71484375,230C403.71484375,221.66666666666666,403.71484375,213.33333333333334,386.8600260416667,204.68913283430106C370.0052083333333,196.04493233526884,336.2955729166667,187.08986467053765,319.4407552083333,182.61233083817206L302.5859375,178.1347970058065",
                  "markerEnd": "url(#arrowhead34)",
                  "style": {
                    "fill": "none",
                    "strokeWidth": "2px",
                    "strokeDasharray": "3"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead34",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 0 0 L 0 0 z",
                      "style": {
                        "fill": "#333"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-router LE-serviceA",
                "id": "L-router-serviceA",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M172.4583918539326,141L158.83772237827716,136.83333333333334C145.21705290262173,132.66666666666666,117.97571395131087,124.33333333333333,104.35504447565545,116C90.734375,107.66666666666667,90.734375,99.33333333333333,90.734375,95.16666666666667L90.734375,91",
                  "markerEnd": "url(#arrowhead35)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead35",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 0 0 L 0 0 z",
                      "style": {
                        "fill": "#333"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-router LE-serviceB",
                "id": "L-router-serviceB",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M236.203125,141L236.203125,136.83333333333334C236.203125,132.66666666666666,236.203125,124.33333333333333,236.203125,116C236.203125,107.66666666666667,236.203125,99.33333333333333,236.203125,95.16666666666667L236.203125,91",
                  "markerEnd": "url(#arrowhead36)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead36",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 0 0 L 0 0 z",
                      "style": {
                        "fill": "#333"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-router LE-serviceC",
                "id": "L-router-serviceC",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M299.9478581460674,141L313.5685276217228,136.83333333333334C327.18919709737827,132.66666666666666,354.43053604868913,124.33333333333333,368.05120552434454,116C381.671875,107.66666666666667,381.671875,99.33333333333333,381.671875,95.16666666666667L381.671875,91",
                  "markerEnd": "url(#arrowhead37)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead37",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 0 0 L 0 0 z",
                      "style": {
                        "fill": "#333"
                      }
                    }}></path></marker></defs></g></g><g parentName="g" {...{
              "className": "edgeLabels"
            }}><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-webapp-router",
                        "className": "edgeLabel L-LS-webapp' L-LE-router"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-iosapp-router",
                        "className": "edgeLabel L-LS-iosapp' L-LE-router"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-router-serviceA",
                        "className": "edgeLabel L-LS-router' L-LE-serviceA"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-router-serviceB",
                        "className": "edgeLabel L-LS-router' L-LE-serviceB"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-router-serviceC",
                        "className": "edgeLabel L-LS-router' L-LE-serviceC"
                      }}></span></div></foreignObject></g></g></g><g parentName="g" {...{
              "className": "nodes"
            }}><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-router-15",
                "transform": "translate(236.203125,160.5)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "19.5",
                  "ry": "19.5",
                  "x": "-66.3828125",
                  "y": "-19.5",
                  "width": "132.765625",
                  "height": "39",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-51.5078125,-9.5)"
                  }}><foreignObject parentName="g" {...{
                      "width": "103.015625",
                      "height": "19"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Graph router`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-serviceA-16",
                "transform": "translate(90.734375,62)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-47.734375",
                  "y": "-29",
                  "width": "95.46875",
                  "height": "58",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-37.734375,-19)"
                  }}><foreignObject parentName="g" {...{
                      "width": "75.46875",
                      "height": "38"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Users`}<br parentName="div"></br>{`subgraph`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-serviceB-17",
                "transform": "translate(236.203125,62)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-47.734375",
                  "y": "-29",
                  "width": "95.46875",
                  "height": "58",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-37.734375,-19)"
                  }}><foreignObject parentName="g" {...{
                      "width": "75.46875",
                      "height": "38"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Products`}<br parentName="div"></br>{`subgraph`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-serviceC-18",
                "transform": "translate(381.671875,62)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-47.734375",
                  "y": "-29",
                  "width": "95.46875",
                  "height": "58",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-37.734375,-19)"
                  }}><foreignObject parentName="g" {...{
                      "width": "75.46875",
                      "height": "38"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Reviews`}<br parentName="div"></br>{`subgraph`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node secondary",
                "id": "flowchart-webapp-13",
                "transform": "translate(78.69140625,274.5)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "5",
                  "ry": "5",
                  "x": "-45.046875",
                  "y": "-19.5",
                  "width": "90.09375",
                  "height": "39",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-35.046875,-9.5)"
                  }}><foreignObject parentName="g" {...{
                      "width": "70.09375",
                      "height": "19"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Web app`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node secondary",
                "id": "flowchart-iosapp-14",
                "transform": "translate(403.71484375,274.5)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "5",
                  "ry": "5",
                  "x": "-41.203125",
                  "y": "-19.5",
                  "width": "82.40625",
                  "height": "39",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-31.203125,-9.5)"
                  }}><foreignObject parentName="g" {...{
                      "width": "62.40625",
                      "height": "19"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`iOS app`}</div></foreignObject></g></g></g></g></g></g></svg></div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      